export function getListViewToggleRef( state ) {
	return state.listViewToggleRef;
}

export function getInserterSidebarToggleRef( state ) {
	return state.inserterSidebarToggleRef;
}
